import { FC } from "preact/compat";
import { Navigate, Outlet } from "react-router-dom";
import { getMe } from "~/core";
import Header from "./Header";

const Me: FC = () => {
    const { me, loading } = getMe();

    if (loading.value) {
        return (
            <div className="flex items-center justify-center w-screen h-screen">
                Loading…
            </div>
        );
    }

    if (!me.value) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="w-screen h-screen max-w-screen max-h-screen overflow-hidden flex flex-col text-[#454554]">
            <Header />
            <div className="w-full h-full">
                <Outlet />
            </div>
        </div>
    );
};

export default Me;
